import { ScoopColumn, ScoopText } from '../../../ui'
import { ScoopButton } from '../../../ui'
import { PlusIcon } from '@phosphor-icons/react'
import styles from './EmptyLiveQuery.module.scss'

export const EmptyLiveQuery = ({ onCreateClick }) => {
    return (
        <ScoopColumn className={styles.container}>
            <ScoopColumn className={styles.textContainer}>
                <ScoopText className={styles.title}>No Live Query connections yet</ScoopText>
                <ScoopText className={styles.description}>
                    Create your first Live Query to analyze data directly from your database without
                    importing it. Configure a connection, select tables, and set up JOIN
                    relationships.
                </ScoopText>
            </ScoopColumn>
            <ScoopButton
                onClick={onCreateClick}
                variant="default"
                leftSection={<PlusIcon size={18} weight="bold" />}
            >
                New Live Query
            </ScoopButton>
        </ScoopColumn>
    )
}
